export default __webpack_public_path__ + "static/qrcode-facebook-1680f471de84ef9e1f52c98cc253ad36.jpeg";